import { render, staticRenderFns } from "./ScreenControlView.vue?vue&type=template&id=bb485f92&scoped=true"
import script from "./ScreenControlView.vue?vue&type=script&lang=js"
export * from "./ScreenControlView.vue?vue&type=script&lang=js"
import style0 from "./ScreenControlView.vue?vue&type=style&index=0&id=bb485f92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb485f92",
  null
  
)

export default component.exports